import { Component, inject, QueryList, ViewChildren } from '@angular/core';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';
import { LabelResponseGuidanceComponent } from '../label-response-guidance/label-response-guidance.component';
import { JsonPipe, KeyValuePipe } from '@angular/common';
import { ScrollItemIntoViewDirective } from '../../scroll-item-into-view.directive';
import { IQuesField } from '../multi-section-form-preview.models';

@Component({
  selector: 'app-current-section-all-fields-preview',
  templateUrl: './current-section-all-fields-preview.component.html',
  styleUrls: ['./current-section-all-fields-preview.component.css'],
  standalone: true,
  imports: [
    LabelResponseGuidanceComponent,
    JsonPipe,
    KeyValuePipe,
    ScrollItemIntoViewDirective,
  ],
})
export class CurrentSectionAllFieldsPreviewComponent {
  public msfps = inject(MultiSectionFormPreviewService);

  @ViewChildren(ScrollItemIntoViewDirective)
  scrollableItems: QueryList<ScrollItemIntoViewDirective>;

  ngOnInit() {
    this.msfps.scrollFieldIntoView$.subscribe((scrollQuesField: IQuesField) => {
      const fieldToBeScrolledIntoView = this.scrollableItems.find(
        (scrollableListItem) =>
          scrollableListItem?.itemId === scrollQuesField?.data?.[0]?.QuestionId,
      );
      if (fieldToBeScrolledIntoView)
        fieldToBeScrolledIntoView.getScrolledIntoView();
    });
  }
}
